import React from 'react';
import Header from './components/header';
import Footer from './components/footer';
import Home from './pages/home';
import Incluir from './pages/incluir';
import Numeros from './pages/numeros';
import Encuentros from './pages/encuentros';
import Glosario from './pages/glosario';
import Movimiento from './pages/movimiento';
import RicoData from './pages/ricodata';
import Mayores from './pages/segmentos/mayores';
import Adolescentes from './pages/segmentos/adolescentes';
import Emprendedora from './pages/segmentos/emprendedora';
import MicroEmprendimiento from './pages/segmentos/micro';
import Funcionario from './pages/segmentos/funcionario';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MenuProvider } from './context/MenuContext';
import { ScrollTop } from './utils';
import './App.css';

function App() {
  return (
    <MenuProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Header />
        <ScrollTop />
        <main>
          <Routes>
            <Route element={<Home />} path="/" />
            <Route element={<Incluir />} path="/que-es-incluir" />
            <Route element={<Numeros />} path="/programa-en-numeros" />
            <Route element={<Encuentros />} path="/encuentros" />
            <Route element={<RicoData />} path="/rico-en-data" />
            <Route element={<Glosario />} path="/glosario" />
            <Route element={<Movimiento />} path="/movimiento" />
            <Route element={<Mayores />} path="/adultos-mayores" />
            <Route element={<Adolescentes />} path="/adolescentes" />
            <Route element={<Emprendedora />} path="/mujer-emprendedora" />
            <Route element={<MicroEmprendimiento />} path="/micro-emprendimientos" />
            <Route element={<Funcionario />} path="/funcionario-municipal" />
            
          </Routes>
        </main>
        
      </BrowserRouter>
    </MenuProvider>
  );
}

export default App;
